export function InformationField({
    label,
    value,
}: {
    label: React.ReactNode;
    value: React.ReactNode;
}) {
    return (
        <div className="w-full flex flex-col gap-1">
            <p className="font-semibold text-text-tertiary text-sm">{label}</p>
            <p className="text-text-quaternary text-sm font-regular">{value}</p>
        </div>
    );
}
